import type { InsertBlockPluginOptions } from '@atlaskit/editor-plugin-insert-block';
import { editorExperiment } from '@atlaskit/tmp-editor-statsig/experiments';

import type { FullPageEditorAppearance } from '../types';

interface Props {
	options: {
		editorAppearance: FullPageEditorAppearance;
		/** @see InsertBlockPluginOptions.itemFilter (EDITOR-6558) */
		itemFilter?: InsertBlockPluginOptions['itemFilter'];
		toolbarButtons: InsertBlockPluginOptions['toolbarButtons'];
	};
}

export function insertBlockPluginOptions({ options }: Props): InsertBlockPluginOptions {
	return {
		allowTables: true,
		allowExpand: true,
		horizontalRuleEnabled: true,
		tableSelectorSupported: editorExperiment('platform_editor_tables_table_selector', true),
		nativeStatusSupported: true,
		showElementBrowserLink: true,
		appearance: options.editorAppearance,
		itemFilter: options.itemFilter,
		toolbarButtons: options.toolbarButtons,
	};
}
